// Class strings shared by the onboarding steps.
//
// The mock repeats the same label / button markup in every step; these keep that
// repetition in one place. They live apart from the components because a module
// that exports both a component and a constant defeats React's fast refresh
// (`react-refresh/only-export-components`).
//
// The `ed-*` classes are the ported CSS — see index.css.

export const onboardingLabelClass =
  'tw:mb-3 tw:block tw:text-xs tw:tracking-[0.15em] tw:text-ed-stone tw:uppercase';

// Flex-centred rather than relying on the default text centring, so a step that
// is waiting on the server can put a spinner beside its label without the label
// shifting off centre.
export const onboardingPrimaryButtonClass =
  'ed-btn-gold tw:inline-flex tw:w-full tw:items-center tw:justify-center tw:gap-3 tw:rounded-sm tw:py-4 tw:text-sm tw:font-medium tw:tracking-[0.15em] tw:text-ed-black tw:uppercase';

export const onboardingSecondaryButtonClass =
  'ed-btn-outline tw:inline-flex tw:w-full tw:items-center tw:justify-center tw:gap-3 tw:rounded-sm tw:py-4 tw:text-sm tw:font-medium tw:tracking-[0.15em] tw:text-white tw:uppercase';

/** The spinner these steps show while a step is being saved. */
export const onboardingSpinnerClass = 'tw:size-4 tw:animate-spin';

/** Group heading inside a step — "Primary Contact", "Accounting". */
export const onboardingGroupHeadingClass = 'tw:mb-6 tw:font-serif tw:text-lg tw:text-ed-gold';

/** Two-up on desktop, stacked on phones. The mock's field pairing. */
export const onboardingRowClass = 'tw:grid tw:grid-cols-1 tw:gap-6 tw:md:grid-cols-2';
